<div class="no-demo-container" nz-row nzAlign="middle" nzJustify="center">
  <div nz-row nzAlign="middle" nzJustify="center" class="mb-[40px] top-header">
    <div
      class="login-title transition-colors duration-200 ease-in-out cursor-pointer"
      [class.active]="currentLoginType === LoginType.QrCode"
      (click)="changeType(LoginType.QrCode)"
    >
      扫码登录
    </div>
    <div class="w-[1px] h-[16px] bg-[#DFE5F0] mx-[16px]"></div>
    <div
      class="login-title transition-colors duration-200 ease-in-out cursor-pointer"
      [class.active]="currentLoginType === LoginType.Account"
      (click)="changeType(LoginType.Account)"
    >
      账号登录
    </div>
  </div>
  @if (currentLoginType === LoginType.Account) {
    <ng-container style="position: relative">
      <form class="form-container" nz-form [formGroup]="form" (ngSubmit)="onSubmit()">
        <nz-form-item>
          <nz-form-control
            class="text-left"
            nzHasFeedback
            [nzValidateStatus]="getFormControl('username')"
            [nzErrorTip]="usernameErrTpl"
          >
            <div class="flex bg-[#F3F6FF] rounded-[6px] p-[13px]">
              <lib-fl-icon name="icon-yonghu" size="20px" color="#4C576C"></lib-fl-icon>
              <!--            <i nz-icon nzType="user" class="text-[20px]"></i>-->
              <input
                class="ml-[12px] flex-1 input-item"
                autofocus
                #usernameInput
                type="text"
                placeholder="请输入账号名"
                formControlName="username"
              />
            </div>
            <ng-template #userTemplate><i nz-icon nzType="user"></i></ng-template>
            <ng-template #usernameErrTpl let-control>
              @if (hasError('username', 'required')) {
                请输入正确的账号名
              }
              @if (hasError('username', 'invalid')) {
                账号名或密码错误
              }
              @if (hasError('username', 'spaceOnly')) {
                账号名不能为空格
              }
            </ng-template>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item nz-row>
          <nz-form-control
            class="text-left"
            nzHasFeedback
            [nzValidateStatus]="getFormControl('password')"
            [nzErrorTip]="passwordErrTpl"
          >
            <div class="flex bg-[#F3F6FF] rounded-[6px] p-[13px]">
              <lib-fl-icon name="icon-mima" size="20px" color="#4C576C"></lib-fl-icon>
              <input
                class="ml-[12px] flex-1 input-item"
                type="password"
                placeholder="请输入密码"
                formControlName="password"
              />
            </div>
            <ng-template #passwordTemplate><i nz-icon nzType="lock"></i></ng-template>
            <ng-template #passwordErrTpl let-control>
              @if (hasError('password', 'required')) {
                请输入密码
              }
              @if (hasError('password', 'spaceOnly')) {
                密码不能为空格
              }
            </ng-template>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item style="margin-bottom: 8px">
          <button
            class="login-btn h-[48px] rounded-[6px] mt-[16px] bg-primary-b1"
            nz-button
            [nzSize]="'large'"
            [nzType]="'primary'"
            [nzLoading]="isSubmitting"
          >
            登录
          </button>
          <p class="mt-sm text-left text-neutral-n3 text-[12px]">
            为维护信息安全，账号密码登录时部分功能将受限。推荐使用
            <span (click)="changeType(LoginType.QrCode)" class="text-primary-b1 point">扫码登录</span>
          </p>
        </nz-form-item>
        @if (authInfo) {
          <nz-form-item nz-row class="non-bottom">
            <div class="other-login-way">
              <div class="other-login-head">
                <span class="other-login-title text-grey-6">其它方式登录</span>
              </div>
              <a [href]="authInfo.link">
                <img [src]="authInfo.icon" [alt]="authInfo.alt" class="oauth2-img" />
              </a>
            </div>
          </nz-form-item>
        }
      </form>
    </ng-container>
  }
  @if (currentLoginType === LoginType.QrCode) {
    <div class="w-[232px] h-[232px] border border-[#DFE5F0] rounded-[8px] flex justify-center items-center">
      <canvas #qrCode (click)="initQrCode()"></canvas>
      <!--      <img class="w-[220px] h-[220px]" [src]="qrCode" (click)="initQrCode()" #qrCodeImg />-->
    </div>
    <div class="text-neutral-n3 mt-[8px] text-[12px]">打开微信APP扫一扫登录</div>
  }
</div>
